import React from "react";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Whychoose from "../components/home/Whychoose";
import { Testimonials } from "../components/home/Testimonials";
import WhatSetsUsApart from "../components/about/WhatSetsUsApart";
import   { AboutWobbleCard }  from "../components/about/WobbleCard";

const AboutPage = () => {
  return (
    <>
      <Navbar />
      
      <div className="relative w-full h-screen overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center brightness-75 scale-110"
        style={{
          backgroundImage:
            "url('https://img.freepik.com/free-photo/curtain-with-sunlight_1339-4061.jpg?size=626&ext=jpg&ga=GA1.1.2132461589.1717658786&semt=ais_hybrid')",
        }}
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-transparent"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center text-white px-6">
        {/* Animated Title */}
        <motion.h1
          initial={{ opacity: 0, y: -50, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="text-4xl sm:text-5xl md:text-7xl font-bold drop-shadow-lg"
        >
          Experience Elegance in Every Detail
        </motion.h1>

        {/* Subtext */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
          className="mt-4 text-lg sm:text-xl md:text-2xl text-gray-200 max-w-3xl"
        >
          Elevate your home with premium blinds and window treatments designed for luxury and comfort.
        </motion.p>

        {/* Glassmorphism Info Card */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.8 }}
          className="mt-8 bg-white/20 backdrop-blur-md p-6 rounded-lg shadow-lg max-w-lg"
        >
          <p className="text-lg text-white font-medium">
            Discover a wide range of styles and custom solutions tailored to your needs.
          </p>
        </motion.div>

    
      </div>
    </div>

      {/* About Section */}
      <div className="bg-white p-10 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-4xl font-bold text-gray-800 mb-6"
        >
          Who We Are
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="text-gray-600 text-lg max-w-3xl mx-auto"
        >
          We offer a wide range of high-quality blinds and shades to enhance the beauty of your space. Shop with confidence and get free shipping!
        </motion.p>
      </div>
<AboutWobbleCard/>
      {/* Our Mission */}
      <div className="bg-gray-100 p-10 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-4xl font-bold text-gray-800 mb-6"
        >
          Our Mission
        </motion.h2>
       
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="text-gray-600 text-lg max-w-3xl mx-auto"
        >
          To provide premium-quality blinds that redefine elegance, ensuring comfort and style with unmatched durability.
        </motion.p>
      </div>
      <WhatSetsUsApart/>
      {/* Why Choose Us */}
      <Whychoose />

      {/* Testimonials */}
      <div className="bg-white py-10">
        <Testimonials />
      </div>
      
      {/* CTA Section */}
      <div className="bg-blue-600 p-10 text-center text-white">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-4xl font-bold mb-6"
        >
          Ready to Upgrade Your Space?
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="text-lg max-w-3xl mx-auto"
        >
          Explore our stunning collection of blinds and experience the perfect blend of style and functionality.
        </motion.p>
        <motion.button
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5 }}
          className="mt-6 bg-white text-blue-600 px-6 py-3 rounded-full font-bold hover:bg-gray-200"
        >
          Shop Now
        </motion.button>
      </div>

      <Footer />
    </>
  );
};

export default AboutPage;